import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-down-more",
  "use": "icon-icon-down-more-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-icon-down-more\">\n<style type=\"text/css\">\n\t#icon-icon-down-more .st0{fill:#FFFFFF;fill-opacity:0;}\n\t#icon-icon-down-more .st1{fill:#EBECFF;}\n</style>\n<g transform=\"translate(-1860 -27)\">\n\t<rect x=\"1860\" y=\"27\" class=\"st0\" width=\"20\" height=\"20\" />\n\t<path class=\"st1\" d=\"M1863.2,34.1l6.4,6.7c0.2,0.2,0.6,0.3,0.9,0c0,0,0,0,0,0l6.4-6.7c0.2-0.3,0.2-0.7,0-0.9\n\t\tc-0.1-0.1-0.3-0.2-0.4-0.2h-12.7c-0.4,0-0.6,0.3-0.6,0.7C1863,33.8,1863.1,34,1863.2,34.1z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-down-more.svg
// module id = W2Zt
// module chunks = 97